// extracted by mini-css-extract-plugin
export var category = "_ih-9";
export var categoryHeader = "_ih-e";
export var container = "_ih-0";
export var group = "_ih-a";
export var groupItems = "_ih-f";
export var groupSeparator = "_ih-j";
export var loading = "_ih-1";
export var noResults = "_ih-3";
export var placeholder = "_ih-2";
export var resultContent = "_ih-5";
export var resultIcon = "_ih-c";
export var resultItem = "_ih-g";
export var resultMeta = "_ih-8";
export var resultSubtitle = "_ih-7";
export var resultSuffix = "_ih-i";
export var resultTitle = "_ih-6";
export var resultsList = "_ih-4";
export var searchGroup = "_ih-d";
export var selected = "_ih-h";
export var subgroup = "_ih-b";